import PropTypes, { ReactElementLike } from 'prop-types';

export const ReactElement = PropTypes.oneOfType([
  PropTypes.node,
  PropTypes.func,
  PropTypes.element,
  PropTypes.string,
  PropTypes.shape({
    ...ReactElementLike,
    key: PropTypes.oneOfType([PropTypes.string])
  })
]);

export const ReactChildrenPropType = PropTypes.oneOfType([ReactElement, PropTypes.arrayOf(ReactElement)]);

export const ReactRefPropType = PropTypes.oneOfType([
  // Either a function
  PropTypes.func,
  // Or the instance of a DOM native element (see the note about SSR)
  PropTypes.shape({ current: PropTypes.instanceOf(Object) })
]);

export const WithStylesClassesPropType = PropTypes.objectOf(PropTypes.string);

export const analyticsPropTypes = PropTypes.shape({
  event: PropTypes.string,
  eventName: PropTypes.string
}).isRequired;

export const roomNightDaysPropTypes = {
  id: PropTypes.string.isRequired,
  guestDayIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  hasIncidentals: PropTypes.bool.isRequired,
  hasLineItems: PropTypes.bool.isRequired,
  bookingGuests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string
    })
  ).isRequired,
  state: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  room: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  costTrackingCode: PropTypes.any,
  company: PropTypes.arrayOf(PropTypes.string).isRequired,
  inboundRate: PropTypes.shape({
    position: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired,
    formatted: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    name: PropTypes.string
  }).isRequired,
  markup: PropTypes.shape({
    position: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired,
    formatted: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    name: PropTypes.string
  }).isRequired,
  taxes: PropTypes.shape({
    position: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired,
    formatted: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    name: PropTypes.string
  }).isRequired,
  fees: PropTypes.shape({
    position: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired,
    formatted: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    name: PropTypes.string
  }).isRequired,
  exceptionDescription: PropTypes.any,
  chargesheetId: PropTypes.any,
  folioIds: PropTypes.arrayOf(PropTypes.any).isRequired
};
